import { render } from "./UnPaidBillsStreams.vue?vue&type=template&id=0c2c903c&scoped=true"
import script from "./UnPaidBillsStreams.vue?vue&type=script&lang=js"
export * from "./UnPaidBillsStreams.vue?vue&type=script&lang=js"

import "./UnPaidBillsStreams.vue?vue&type=style&index=0&id=0c2c903c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2c903c"]])

export default __exports__